module.exports = __webpack_public_path__ + "img/cart.282ce96.png";